import { ChevronRightRounded } from '@mui/icons-material';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Switch } from '@mui/material';
import { setTransportSelectedItemConditionOptions, setTransportSelectedItemParkingPointsOptions } from 'app/actions/map';
import { MapTransportTrackIntervalMenu } from 'app/pages/Map';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const MapTransportConditionTrackList = () => {
  const dispatch = useDispatch();
  const { ref: mapRef } = useSelector((state) => state.map);
  const { conditions, parkingPointsOptions, conditionOptions, device_type } = useSelector((state) => state.map.transportSelectedItem);
  const [anchorTrackIntervalEl, setAnchorTrackIntervalEl] = useState(null);

  const handleTrackVisibleChange = () => {
    dispatch(
      setTransportSelectedItemConditionOptions({
        ...conditionOptions,
        visible: !conditionOptions.visible,
      })
    );

    if (conditions.length !== 0) {
      mapRef.current.handleClosePopup();
      mapRef.current.handleFlyTo([conditions[conditions.length - 1].data.lat, conditions[conditions.length - 1].data.lon]);
    }
  };

  const handleParkingPointsVisibleChange = () =>
    dispatch(
      setTransportSelectedItemParkingPointsOptions({
        ...parkingPointsOptions,
        visible: !parkingPointsOptions.visible,
      })
    );

  const formatInterval = (hour) => {
    moment.relativeTimeThreshold('h', 25);
    return `${hour > 1 ? '' : '1 '}${moment.duration(hour, 'hours').humanize()}`;
  };

  const handleTackIntervalOpen = (event) => {
    setAnchorTrackIntervalEl(event.currentTarget);
  };

  const handleTackIntervalClose = () => {
    setAnchorTrackIntervalEl(null);
  };

  return (
    <List
      disablePadding
      sx={(theme) => ({
        '.MuiListItem-root': {
          padding: theme.spacing(0),
          '.MuiListItemButton-root': {
            padding: theme.spacing(1, 2),
            overflow: 'hidden',
            '&:after': {
              content: '""',
              width: '100%',
              height: '1px',
              bgcolor: theme.palette.divider,
              position: 'absolute',
              bottom: '0',
            },
            '&:hover': {
              bgcolor: 'transparent',
            },
            '.MuiListItemText-root': {
              display: 'flex',
              margin: theme.spacing(0),
              justifyContent: 'space-between',
              '.MuiTypography-root': {
                lineHeight: '24px',
              },
            },
            '.MuiListItemIcon-root': {
              minWidth: '28px',
              justifyContent: 'flex-end',
            },
            '.MuiSwitch-switchBase:hover': {
              bgcolor: 'transparent',
            },
          },
          '&:last-of-type': {
            '.MuiListItemButton-root:after': {
              display: 'none',
            },
          },
        },
      })}>
      <ListItem>
        <ListItemButton dense onClick={handleTrackVisibleChange}>
          <ListItemText primary='Показывать трек на карте' />
          <Switch size='small' edge='end' disableRipple checked={conditionOptions.visible} />
        </ListItemButton>
      </ListItem>
      {['galileosky'].includes(config.transportDeviceTypes[device_type]) && (
        <ListItem>
          <ListItemButton dense onClick={handleParkingPointsVisibleChange}>
            <ListItemText primary='Показывать парковки на карте' />
            <Switch size='small' edge='end' disableRipple checked={parkingPointsOptions.visible} />
          </ListItemButton>
        </ListItem>
      )}
      <ListItem>
        <ListItemButton dense onClick={handleTackIntervalOpen}>
          <ListItemText primary='Интервал отображения' secondary={formatInterval(conditionOptions.interval)} />
          <ListItemIcon>
            <ChevronRightRounded fontSize='small' />
          </ListItemIcon>
        </ListItemButton>
        <MapTransportTrackIntervalMenu anchorEl={anchorTrackIntervalEl} open={!!anchorTrackIntervalEl} onClose={handleTackIntervalClose} />
      </ListItem>
    </List>
  );
};

export default MapTransportConditionTrackList;
